function Divider() {
    return <hr></hr>
}

export default Divider;